import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin"
gsap.registerPlugin(ScrollToPlugin);

export const getDisplayMode = () => {
  var layoutMode = null;
  var LAYOUTMODE__DESKTOP = 1;
  var LAYOUTMODE__MODILE = 2;
  var BREAK_POINT = "(min-width: 769px)";

  function matchMedia() {
    if (window.matchMedia(BREAK_POINT).matches) {
      if (layoutMode == LAYOUTMODE__DESKTOP) return;
      layoutMode = LAYOUTMODE__DESKTOP;

    } else {
      if (layoutMode == LAYOUTMODE__MODILE) return;
      layoutMode = LAYOUTMODE__MODILE;
    }

    return layoutMode;
  }

  function resize() {
    return matchMedia();
  }

  window.addEventListener('resize', function () {
    return resize()
  });

  return resize();

};

export const spanWrapText = (targets) => {
  targets.forEach(function (target) {
    let nodes = [...target.childNodes];
    let textBox = '';
    nodes.forEach(function (node) {
      if (node.nodeType == 3) { //テキストの場合
        let text = node.textContent.replace(/\r?\n/g, ''); //テキストから改行コード削除
        text.split('').forEach(function (t) {
          if (t !== " ") {
            textBox += '<span class="char">' + t + '</span>';
          } else {
            textBox += t;
          }
        });
      } else if (node.contains(node) == true) { // テキストではなく、子ノード(=span要素)を持つ
        let childNodes = [...node.childNodes];
        let childTextBox = '';
        childNodes.forEach(function (childeNode) {
          if (childeNode.nodeType == 3) { //テキストの場合
            let childeText = childeNode.textContent.replace(/\r?\n/g, ''); //テキストから改行コード削除
            childeText.split('').forEach(function (ct) {
              if (ct !== " ") {
                childTextBox += '<span class="char">' + ct + '</span>';
              } else {
                childTextBox += ct;
              }
            });
          } else if (childeNode.contains(node) == true) {
            // そのまま連結
            childTextBox = childTextBox + childeNode.outerHTML;
          } else {
            childTextBox = childTextBox + childeNode.outerHTML;
          }
        })

        node.innerHTML = childTextBox
        textBox = textBox + node.outerHTML;

      } else { // テキストではなく、br要素などspan要素以外の要素を持つ
        textBox = textBox + node.outerHTML;
      }
    })
    target.innerHTML = textBox
  })

  return targets;
};

export const smoothScroll = () => {
  console.log('test')
  const headerHeight = document.querySelector('#site-header').clientHeight;

  function setSmoothScroll() {
    const smoothScrollTrigger = document.querySelectorAll('.anc-nav');

    for (let i = 0; i < smoothScrollTrigger.length; i++) {
      smoothScrollTrigger[i].addEventListener('click', (e) => {
        e.preventDefault();
        let href = smoothScrollTrigger[i].getAttribute('href');
        gsap.to(window, {
          ease: "power2.Out",
          duration: .5,
          scrollTo: {
            y: href,
            // offsetY: headerHeight
          }
        });
      });
    }
  }

  setSmoothScroll();
};

export const setModal = () => {
  const body = document.querySelector('body')

  function openModal(trigger, target) {
    target.classList.add('is-open');
    body.classList.add('no-scroll');
  }

  function closeModal(trigger, target) {
    target.classList.remove('is-open');
    body.classList.remove('no-scroll');
  }

  const triggers = document.querySelectorAll('.js-modal-trigger');

  triggers.forEach((trigger) => {
    const contentsId = trigger.getAttribute('modal-content');
    const target = document.getElementById(contentsId);
    const closeBtn = target.querySelector('.modal-close');
    const modalBg = target.querySelector('.modal-bg');

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openModal(trigger, target);
    });

    closeBtn.addEventListener('click', function () {
      closeModal(trigger, target);
    });

    modalBg.addEventListener('click', function () {
      closeModal(trigger, target);
    });
  })
}

export const globalNav = () => {
  const nav = document.getElementById("js-globalnav");
  const btn = document.getElementById("js-gn-menu");
  // const menu = nav.getElementsByClassName("gnav-item");

  const open = () => {
    document.querySelector('body').style.overflow = "hidden";
    nav.classList.add("is-open");
  };

  const close = () => {
    document.querySelector('body').style.overflow = "auto";
    nav.classList.remove("is-open");
  };

  btn.addEventListener("click", () => {
    btn.querySelector('.hamburger').classList.toggle("is-active");
    btn.querySelector('.hamburger').classList.contains("is-active") ? open() : close();
  });

  nav.classList.remove('preload');
};

export const setAccordion = () => {
  const box = document.querySelectorAll(".js-accordion-box");

  if (box.length) {
    box.forEach(el => {
      const btn = el.querySelector(".js-accordion-head"),
        content = el.querySelector(".js-accordion-content");

      let open = false

      btn.addEventListener('click', () => {
        if (open) {
          gsap.to(content, {
            height: 0,
            direction: .6,
            ease: "Quint.easeOut",
          })
          el.classList.remove('is-open')
        } else {
          gsap.to(content, {
            height: 'auto',
            direction: .6,
            ease: "Quint.easeOut",
          })
          el.classList.add('is-open')
        }
        open = !open
      })
    });
  }
};

export const fetchGraphQL = async (query) => {
  const uri = new URL(window.location.href);
  const endpoint = `${uri.protocol}//${uri.host}/${uri.host === 'www.aiia-pub.com' ? 'apps/note/' : ''}graphql`;

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + btoa('aiia:MSseUpSTy3')
      },
      body: JSON.stringify({ query }),
    });

    const result = await response.json();

    if (result.errors) {
      console.error("GraphQL Errors:", result.errors);
      throw new Error("GraphQL query failed");
    }

    return result.data;
  } catch (error) {
    console.error("GraphQL Fetch Error:", error);
    return null;
  }
}

export const setHashDetect = () => {
  const headerHeight = document.querySelector('#site-header').clientHeight;
  const hash = location.hash;

  if (hash && hash !== '#timeline') {
    gsap.to(window, {
      ease: "power2.Out",
      duration: 0.01,
      scrollTo: {
        y: 0,
      },
      onComplete: () => {
        gsap.to(window, {
          ease: "power2.Out",
          duration: .5,
          scrollTo: {
            y: document.getElementById(hash.replace('#', '')),
            offsetY: headerHeight
          }
        });
      }
    });
  }
};